import Staging from './staging';

export default {
  ...Staging,
  // After this point, you can override any setting from Staging or add a new one.
};
